import { TEXTS } from '../texts';
import { IVideoMediafile } from '../types';

const DEFAULT_IMAGES_DURATION = 10000;

export const replaceTextByErrorMessage = (message: string): string => {
  if (/already exists/.test(message)) {
    return TEXTS.DUPLICATE_MEDIAFILE_ERROR;
  }

  return message;
};

export const getPlayDuration = (file: IVideoMediafile) => {
  if (file.playDuration) {
    return file.playDuration;
  }

  return file.duration || DEFAULT_IMAGES_DURATION;
};
